import { render, staticRenderFns } from "./icon-suppliers.vue?vue&type=template&id=ed66de0c&"
import script from "./icon-suppliers.vue?vue&type=script&lang=js&"
export * from "./icon-suppliers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports